import { Search } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useExpeditionFilters } from "../pendingExpeditions/useExpeditionFilters.reducer";
import { CustomsCombobox } from "@/components/ui/customs/customs-combobox";
import { useGetCustoms } from "@/api/customs.api";
import { FilterV2, useFilterV2 } from "@/components/shared/filter-v2";
import { SelectV2 } from "@/components/ui/customs/select-v2";
import { UnifiedInput } from "@/components/ui/customs/unified-input";
import { DateRangePicker } from "@/components/ui/customs/date-range-picker";
import { CustomQuotationTypeEnum } from "@/constants/enums/customQuotationType.enum";
import { useCustomQuotationTypeOptions } from "@/hooks/useEnumOptions";

type FiltersProps = {
  filters: ReturnType<typeof useExpeditionFilters>["filters"];
  actions: ReturnType<typeof useExpeditionFilters>["actions"];
};

export const FiltersPendingCustomQuotations = ({ filters, actions }: FiltersProps) => {
  const { data: customs = [] } = useGetCustoms();
  const { isOpen, toggle } = useFilterV2();
  const customQuotationTypeOptions = useCustomQuotationTypeOptions();
  const { t } = useTranslation("boQuotations");

  return (
    <FilterV2 isOpen={isOpen} onToggle={toggle} onReset={actions.resetFilters} className="w-full">
      <UnifiedInput
        inputType="text"
        leftElement={<Search />}
        value={filters.search}
        onChange={(v) => actions.setSearch(String(v ?? ""))}
        placeholder={t("pendingFilters.searchPlaceholder")}
        wrapperClassName="min-w-[200px] flex-1 md:max-w-[300px]"
        subWrapperClassName="h-[2.4rem]"
      />
      <CustomsCombobox
        customs={customs}
        value={filters.customId || undefined}
        onValueChange={(v) => actions.setCustomId(v ?? "")}
        clearable
        className="min-w-[200px] flex-1 md:max-w-[300px]"
      />
      <DateRangePicker
        placeholder={t("pendingFilters.createdAtPlaceholder")}
        value={filters.createdAt}
        onChange={(range) => actions.setCreatedAtRange(range)}
        className="min-w-[200px] flex-1 md:max-w-[300px]"
      />
      <SelectV2
        placeholder={t("pendingFilters.typePlaceholder")}
        options={customQuotationTypeOptions}
        value={filters.customQuotationType ?? ""}
        onChange={(v) => actions.setCustomQuotationType(v ? (v as CustomQuotationTypeEnum) : null)}
        clearable
        searchable={false}
        wrapperClassName="min-w-[200px] flex-1 md:max-w-[300px]"
      />
    </FilterV2>
  );
};
